module.exports = __webpack_public_path__ + "img/GradeOutlined.b914c3cf.svg";